module.exports = __webpack_public_path__ + "media/images/upload_4-0a5f4724.png";